module.exports = "/_next/static/images/leaf-monotone-059ef9def7d44b413687f69c8a2df77e.svg";